import { Col } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import JobDetail from "../Client/Job/JobDetail";
import ApplyJob from "../Consultant/ApplyJob";

import constants from "../Redux/constants";

const ViewJobDetail = (props) => {
  const { userRole } = useSelector((state) => state.userStore);
  return (
    <Col xs={{ span: 24 }}>
      {userRole === constants.roles.client ? (
        <JobDetail jobId={props.jobId} />
      ) : (
        <ApplyJob jobId={props.jobId} />
      )}
    </Col>
  );
};

export default ViewJobDetail;
